import React, { useState } from 'react';
import './Navbar.css';

// SVG Icons
import HomeIcon from '../assets/Menu/home.svg';
import DevicesIcon from '../assets/Menu/devices.svg';
import ProfileMenuIcon from '../assets/Menu/profile.svg';
import SavingsMenuIcon from '../assets/Menu/savings.svg';

const Navbar = () => {
  const [activeItem, setActiveItem] = useState('home');

  const NavItem = ({ icon, label, itemKey, isActive, onClick }) => (
    <button className={`nav-item ${isActive ? 'active' : ''}`} onClick={onClick}>
      <img src={icon} alt={label} className="nav-icon" />
      <span className="nav-label">{label}</span>
    </button>
  );

  const handleNavClick = (item) => {
    setActiveItem(item);
    console.log(`${item} clicked`);
  };

  return (
    <nav className="bottom-nav responsive-container">
      <div className="nav-container">
        <NavItem
          icon={HomeIcon}
          label="Home"
          itemKey="home"
          isActive={activeItem === 'home'}
          onClick={() => handleNavClick('home')}
        />
        <NavItem
          icon={DevicesIcon}
          label="Devices"
          itemKey="devices"
          isActive={activeItem === 'devices'}
          onClick={() => handleNavClick('devices')}
        />
        <NavItem
          icon={ProfileMenuIcon}
          label="Community"
          itemKey="community"
          isActive={activeItem === 'community'}
          onClick={() => handleNavClick('community')}
        />
        <NavItem
          icon={SavingsMenuIcon}
          label="Savings"
          itemKey="savings"
          isActive={activeItem === 'savings'}
          onClick={() => handleNavClick('savings')}
        />
      </div>
    </nav>
  );
};

export default Navbar;
